'use es6';

import http from 'hub-http/clients/apiClient';
import { batchScheduler } from 'batch-promise';
import { makeCachedScheduler } from './makeCachedScheduler';
const BASE_URL = 'inbounddb-objects/v1/preview';
const MAX_REQUEST_SIZE = 200;
const identifyCall = input => `${input.objectTypeId}:${input.objectId}`;
const crmObjectPreviewScheduler = batchScheduler().read().identity(identifyCall).partition(() => 'crmObjectPreview').execute(calls => http.post(BASE_URL, {
  data: Object.values(calls).reduce((body, {
    objectTypeId,
    objectId
  }) => {
    const objectIds = body[objectTypeId] || [];
    objectIds.push(objectId);
    body[objectTypeId] = objectIds;
    return body;
  }, {})
}).then(response => {
  return Object.entries(response).reduce((results, [objectTypeId, objects]) => {
    for (const [objectId, object] of Object.entries(objects)) {
      results[identifyCall({
        objectTypeId,
        objectId
      })] = object;
    }
    return results;
  }, {});
})).extract(({
  response,
  identity
}) => {
  if (!response[identity]) {
    throw new Error(`No results for ${identity}`);
  }
  return response[identity];
}).chunkSize(MAX_REQUEST_SIZE).window(200);
export const CrmObjectPreviewBatchRequestClient = makeCachedScheduler(crmObjectPreviewScheduler);
export const __resetCrmObjectPreviewCache = () => {
  CrmObjectPreviewBatchRequestClient.clearCache();
};